"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var Survey = _interopRequireWildcard(require("survey-core"));
var SurveyReact = _interopRequireWildcard(require("survey-react-ui"));
var _headerSurvey = _interopRequireDefault(require("./headerSurvey"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CustomSurveyPage = /*#__PURE__*/function (_SurveyReact$SurveyPa) {
  (0, _inherits2.default)(CustomSurveyPage, _SurveyReact$SurveyPa);
  var _super = _createSuper(CustomSurveyPage);
  function CustomSurveyPage() {
    (0, _classCallCheck2.default)(this, CustomSurveyPage);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(CustomSurveyPage, [{
    key: "reupdateQuestion",
    value:
    /**
     * Analyze list question model to detect Header Question
     * And then group question by Page, by Header or by Panel
     * @returns list question model
     */
    function reupdateQuestion() {
      var questionRows = this.panelBase.rows;
      var rowsHeader = [];
      var questionUpdate = [];
      var isHeader = false;
      questionRows.forEach(function (item) {
        if (item.elements.length > 0 && item.elements[0] instanceof Survey.QuestionExpressionModel && item.elements[0].jsonObj && item.elements[0].jsonObj.internalType !== 'expression') {
          if (rowsHeader.length > 0) {
            questionUpdate.push(rowsHeader);
            rowsHeader = [];
          }
          isHeader = true;
          rowsHeader.push(item);
        } else if (isHeader) {
          rowsHeader.push(item);
        } else {
          questionUpdate.push(item);
        }
      });
      if (rowsHeader.length > 0) {
        questionUpdate.push(rowsHeader);
        rowsHeader = [];
      }
      return questionUpdate;
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var _this = this;
      var rows = [];
      var rowsHeader = this.reupdateQuestion();
      rowsHeader.forEach(function (questionInfo) {
        if (Array.isArray(questionInfo)) {
          rows.push( /*#__PURE__*/_react.default.createElement(_headerSurvey.default, {
            survey: _this.survey,
            creator: _this.creator,
            css: _this.css,
            questions: questionInfo,
            needClearErrorsWhenAllQuestionIsEmpty: _this.props.needClearErrorsWhenAllQuestionIsEmpty
          }));
        } else {
          rows.push(_this.createRow(questionInfo));
        }
      });
      return rows;
    }
  }, {
    key: "createRow",
    value: function createRow(row) {
      return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyRow, {
        key: row.id,
        row: row,
        survey: this.survey,
        creator: this.creator,
        css: this.css
      });
    }
  }]);
  return CustomSurveyPage;
}(SurveyReact.SurveyPage);
var _default = CustomSurveyPage;
exports.default = _default;